const activeCarriersQueryKeys = {
    all: ['active_carriers'] as const,
    list: (accountId: string) => [...activeCarriersQueryKeys.all, accountId, 'list'] as const,
};

export default activeCarriersQueryKeys;
